import React, {useState} from 'react'
import styled from 'styled-components'
import {FiChevronDown} from 'react-icons/fi'
import {theme} from '../theme'
import {useClickOutside} from '../utils'

interface IProps {
  className?: string
  value?: string | number
  label?: string
  placeHolder?: string
  onSelect: (id: any) => void
  options: any[]
  fieldKey: string
  displayField: string
  width?: string
  selectionWidth?: string
  fullHeight?: boolean
}

function DropdownClass({
  className,
  value,
  label,
  placeHolder,
  onSelect,
  options = [],
  fieldKey = 'id',
  displayField,
  selectionWidth,
  fullHeight = false
}: IProps) {
  const [open, setOpen] = useState(false)
  const dropdownRef = React.useRef(null)
  useClickOutside(dropdownRef, () => setOpen(false), open)

  const handleSelect = (id: any) => {
    onSelect(id)
    setOpen(!open)
  }

  const selectedValue = value && options.find(item => item[fieldKey] === value)
  const displayValue = selectedValue ? selectedValue[displayField] : undefined

  return (
    <div className={className}>
      {label && <label>{label}</label>}
      <DropdownContainer className="dropdown-container" selectionWidth={selectionWidth} ref={dropdownRef}>
        <Item className={selectedValue ? 'dropdown-item-placeholder' : 'dropdown-item'} onClick={() => setOpen(!open)}>
          {displayValue || placeHolder}
        </Item>
        <IconElement className="dropdown-icon-element" onClick={() => setOpen(!open)}>
          <FiChevronDown />
        </IconElement>
        <DropdownContent className="dropdown-content" $fullHeight={fullHeight} style={{display: open ? 'block' : 'none'}}>
          {options.map((item, index) => (
            <DropdownItem
              key={`dropwdown-${item[fieldKey]}-${index}`}
              onClick={() => handleSelect(item[fieldKey])}
              selected={value === item[fieldKey]}
            >
              {item[displayField]}
            </DropdownItem>
          ))}
        </DropdownContent>
      </DropdownContainer>
    </div>
  )
}

const Item = styled.div`
  color: #000;
  cursor: pointer;
`

const DropdownContainer = styled.div<{selectionWidth?: string}>`
  margin-top: 7px;
  display: block;
  border: 1px solid ${theme.color.darkGray};
  border-radius: 4px;
  box-shadow: none;
  padding: 0.8rem;
  background-color: #fff;
  font-size: ${theme.fontSize.small};
  position: relative;
  width: ${props => props.selectionWidth || '100%'};
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    width: 100%;
  }
`
const DropdownContent = styled.div<{$fullHeight: boolean}>`
  width: calc(100% + 2px);
  position: absolute;
  margin-top: 3px;
  margin-left: -1px;
  z-index: 2;
  left: 0;
  background-color: #fff;
  font-size: ${theme.fontSize.small};
  border-left: 1px solid ${theme.color.darkGray};
  border-right: 1px solid ${theme.color.darkGray};
  border-bottom: 1px solid ${theme.color.darkGray};
  border-radius: 0 0 4px 4px;
  max-height: ${props => (props.$fullHeight ? 'none' : '150px')};
  overflow: auto;
  cursor: pointer;
`

const DropdownItem = styled.div<{selected?: boolean}>`
  padding: 0.5rem;
  &:hover {
    background-color: #eee;
  }
  background-color: ${props => props.selected && '#eee'};
`

const IconElement = styled.span`
  height: 100%;
  width: 32px;
  top: 0;
  overflow: hidden;
  position: absolute;
  display: inline-block;
  z-index: 1;
  right: 9px;
  left: auto;
  bottom: 0;
  color: #000;
  cursor: pointer;
  > * {
    height: 100%;
    width: 2.4rem;
    fill: #fff;
  }
`

export const Dropdown = styled(DropdownClass)`
  width: ${props => props.width || '100%'};
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    width: 100%;
    label {
      font-size: 1.5rem;
    }
  }
`
